import React, { forwardRef, type CSSProperties } from "react";

import { cn } from "@fitness-app/utils/src/styles/cn";

export interface ActionProps extends React.HTMLAttributes<HTMLButtonElement> {
  active?: {
    fill: string;
    background: string;
  };
  cursor?: CSSProperties["cursor"];
}

export const Action = forwardRef<HTMLButtonElement, ActionProps>(
  ({ active, className, cursor, style, ...props }, ref) => {
    return (
      <button
        ref={ref}
        {...props}
        className={cn(
          "absolute right-8 top-[1.72rem] fill-gray-700 outline-none hover:fill-gray-900 active:fill-gray-900",
          className,
        )}
        tabIndex={0}
        style={
          {
            ...style,
            cursor,
            "--fill": active?.fill,
            "--background": active?.background,
          } as CSSProperties
        }
      />
    );
  },
);

Action.displayName = "Action";
